// frontend/src/pages/LicenseTerms.js
//
// The software licence agreement, for shops running GlamGo themselves.
//
// The two periods the text quotes — the offline grace window and when we warn
// about an expiry — come from the backend's own configuration rather than from
// the prose, so the document cannot state one number while the software enforces
// another.
import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalDoc from '../components/LegalDoc';
import { useCompany } from '../utils/useCompany';
import { getIntlLocale } from '../i18n';

export default function LicenseTerms() {
  const company = useCompany();
  const { t } = useTranslation();

  // "30, 14 and 3 days" in English; "30, 14 και 3 ημέρες" in Greek. Joining with
  // a hardcoded " and " is the sort of thing that reads fine to whoever wrote it
  // and wrong to everybody else, so the conjunction comes from Intl and the noun
  // from the catalogue.
  const days = company.licenseWarnDays || [30, 14, 3];
  const list = typeof Intl !== 'undefined' && Intl.ListFormat
    ? new Intl.ListFormat(getIntlLocale(), { style: 'long', type: 'conjunction' }).format(days.map(String))
    : days.join(', ');

  return (
    <LegalDoc
      namespace="licenseTerms"
      values={{
        version: company.licenseTermsVersion || '1.0',
        grace: company.licenseGraceDays ?? 14,
        warn: t('licenseTerms.warnDays', { list }),
      }}
    />
  );
}
